(function () {

    'use strict';

    angular
        .module('committeeEditModule')
        .controller('CommitteeAddController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {
            
        topBarService.setTitleAndIcon('New Committee', 'fa fa-users');
        $scope.committee = {};

    }
})();